const C = require("../constants");

const totalSale = total_sale => {
    return {
        type: C.TOTAL_SALE,
        total_sale
    }
};

export {totalSale};


// WEBPACK FOOTER //
// ./src/actions/SaleTotalAction.js